import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-json",
  "use": "icon-json-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-json\"><path d=\"M12 3v2c-1.2 0-4 .4-4 4 0 1.4 0 5.2-2.6 7C8 17.8 8 21.6 8 23c0 3.6 2.8 4 4 4v2c-2.8 0-6-1.6-6-6 0-3.2-.4-6-4-6v-2c3.6 0 4-2.8 4-6 0-4.4 3.2-6 6-6m8 0c2.8 0 6 1.6 6 6 0 3.2.4 6 4 6v2c-3.6 0-4 2.8-4 6 0 4.4-3.2 6-6 6v-2c1.2 0 4-.4 4-4 0-1.4 0-5.2 2.6-7-2.442-1.69-2.59-5.147-2.6-6.72V9c0-3.6-2.8-4-4-4Zm-3 9v14h-2V12zm0-6v4h-2V6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol